// extracted by mini-css-extract-plugin
export default {"btn":"UnblurBtn_btn__yTrbl","text":"UnblurBtn_text__lIPxP"};